import { useState } from 'react';
import type { Title } from '@/services/title';

export default () => {
  const [showForm, setShowForm] = useState(false);
  const [pickedData, setPickedData] = useState<Title | null>(null);
  const [loading, setLoading] = useState(false);

  const closeForm = () => {
    setShowForm(false);
    setPickedData(null);
  };

  const openCreateForm = () => {
    setPickedData(null);
    setShowForm(true);
  };

  const openEditForm = (data: Title) => {
    setPickedData(data);
    setShowForm(true);
  };

  return {
    // State
    showForm,
    pickedData,
    loading,
    // Actions
    setShowForm,
    setPickedData,
    setLoading,
    closeForm,
    openCreateForm,
    openEditForm,
  };
};
